/**
 * Popup Content: a Popup Modal with its content provided by a custom component
 * 
 * Aria calls Popup Modals: Modal Dialog Box
 * See https://www.w3.org/WAI/GL/wiki/Using_ARIA_role%3Ddialog_to_implement_a_modal_dialog_box
 *
 * DO NOT COPY THE POPUP CONTENT COMPONENT
 * - Instead copy popup-site-ui-kit and modify that to create a custom popup modal
 * 
 * DO NOT MODIFY THE POPUP CONTENT COMPONENT
 * - Instead modify your custom popup content component
 * 
 */

import {
  Component,
  OnInit,
  Input,
  Output,
  ElementRef,
  EventEmitter
} from '@angular/core';

import { PopupModalService } from 'app/services/popup-modal.service';
import { ContentService } from 'app/services';
import { SiteCatalystService } from 'app/services/site-catalyst.service';

@Component({
  selector: 'popup-content',
  templateUrl: './popup-content.component.html'
})

export class PopupContentComponent implements OnInit {

  elementsToFocusOn: any = [];
  elementThatTriggeredThisModal: any;
  focusIndex: number = 0;     // element in tooltip modal the user is focused on
  isDismissable: boolean = true;
  isOpen: boolean = false;
  popupContentComponent: any = "";
  params: any = "";
  branding: any;
  modalData: any;

  constructor(
    private popupModalService:PopupModalService,
    private modalElementRef: ElementRef,
    private _contentService: ContentService,
    private scService: SiteCatalystService) {
  }

  ngOnInit() {

        
    this.popupModalService.openPopupContent.subscribe(($properties)=> {

      if ($properties.popupContentComponent) {
          this.popupContentComponent = $properties.popupContentComponent;
      } else {
          // Problem: openPopupContent component not found
          return;
      }
      if ($properties.popupContentParams) {
          this.params = $properties.popupContentParams;
      }
      
      //flex banner popup and link click site cat calls
      if ($properties.popupContentComponent === 'popup-site-redirect') {
          this.scService.setSCPageData("speedbumpDisplay", null);   
      }
      
      this.open();
    });

    this.popupModalService.closePopupContent.subscribe(()=> {
      this.close();
    });

    // Change what happens when user clicks on backdrop behind modal
    this.popupModalService.dismissablePopupContent.subscribe(()=> {
      this.isDismissable = true;  // clicking outside modal will close it
    });

    this.popupModalService.notDismissablePopupContent.subscribe(()=> {
      this.isDismissable = false;  // clicking outside modal will not close it
    });

    // remember what was clicked to open this model so focus can return to it
    this.popupModalService.setTriggerElement.subscribe((triggerElement)=> {
      this.elementThatTriggeredThisModal = triggerElement;
    });
    
  }

  // User clicked on backdrop
  onBackdropClick(event) {

    // close modal if dismissible
    if (this.isDismissable) {
      this.close();
    }
  }
  
  onKeydown(event) {

    // if not open, ignore keydown
    if (!this.isOpen) return;

    // ignore tab down so browser does not move the focus
    if (event.key === 'Tab') {
      event.preventDefault();
    }

  }

  // Handle ADA keystroke requirements
  onKeyup(event) {

    // if not open, ignore keyup
    if (!this.isOpen) return;

    // find in the modal all interactive elements the user could focus on
    if (this.elementsToFocusOn.length == 0) {
      this.elementsToFocusOn = this.modalElementRef.nativeElement.querySelectorAll('a[href], button, input, select, textarea, *[tabindex]');
      this.focusIndex = this.elementsToFocusOn.length - 1;  // focus-here is generally the last element
    }

    // trap tab so it can not escape modal, per ADA specs
    if (event.key === 'Tab') {
      // move the focus to the next one, wrap if needed
      if (++this.focusIndex >= this.elementsToFocusOn.length) {
        this.focusIndex = 0;
      }
      this.elementsToFocusOn[this.focusIndex].focus();
    }

    // escape
    if (event.key === "Escape") {
      this.close();
    }
  }

  // Opens the popup content
  public open() {
    this.isOpen = true;

    // wait for modal component to render before setting focus
    setTimeout(() => {
        if (this.modalElementRef.nativeElement.querySelector('.focus-here')) {
          this.modalElementRef.nativeElement.querySelector('.focus-here').focus();
        }
      }, 250);
  }

  // Closes the popup content
  public close() {
    this.isOpen = false;
    this.elementsToFocusOn = []; // clear element for next modal
    
    if (this.elementThatTriggeredThisModal) {
      this.elementThatTriggeredThisModal.nativeElement.focus();
    }
  }
}

